import type { Messages } from "./en";

export const th: Messages = {
  "app.name": "Auth Platform",
  "app.console": "คอนโซล",
  "common.loading": "กำลังโหลด…",
  "common.retry": "ลองอีกครั้ง",
  "common.reload": "โหลดใหม่",
  "common.save": "บันทึก",
  "common.saving": "กำลังบันทึก…",
  "common.cancel": "ยกเลิก",
  "common.close": "ปิด",
  "common.create": "สร้าง",
  "common.edit": "แก้ไข",
  "common.delete": "ลบ",
  "common.confirm": "ยืนยัน",
  "common.copy": "คัดลอก",
  "common.showPassword": "แสดงรหัสผ่าน",
  "common.hidePassword": "ซ่อนรหัสผ่าน",
  "common.copied": "คัดลอกแล้ว",
  "common.search": "ค้นหา",
  "common.yes": "ใช่",
  "common.no": "ไม่ใช่",
  "common.none": "ไม่มี",
  "common.enabled": "เปิดใช้งาน",
  "common.disabled": "ปิดใช้งาน",
  "common.add": "เพิ่ม",
  "common.remove": "นำออก",
  "common.moveUp": "เลื่อนขึ้น",
  "common.moveDown": "เลื่อนลง",
  "common.never": "ไม่เคย",
  "common.next": "ถัดไป",
  "common.previous": "ก่อนหน้า",
  "common.rowsPerPage": "แถวต่อหน้า",
  "common.errorTitle": "เกิดข้อผิดพลาด",
  "common.readOnly": "อ่านอย่างเดียว",
  "common.noPermission": "คุณไม่มีสิทธิ์แก้ไขส่วนนี้",
  "common.saved": "บันทึกแล้ว",
  "common.all": "ทั้งหมด",
  "common.download": "ดาวน์โหลด",
  "common.optional": "ไม่บังคับ",

  "nav.overview": "ภาพรวม",
  "nav.authentication": "การยืนยันตัวตน",
  "nav.users": "ผู้ใช้",
  "nav.signInMethod": "วิธีเข้าสู่ระบบ",
  "nav.roles": "บทบาท",
  "nav.customFields": "ฟิลด์เพิ่มเติม",
  "nav.applications": "แอปพลิเคชัน",
  "nav.oauthClients": "OAuth clients",
  "nav.monitor": "การตรวจสอบ",
  "nav.auditLogs": "บันทึกการใช้งาน",
  "nav.settings": "การตั้งค่า",
  "nav.branding": "แบรนด์",
  "nav.data": "ข้อมูลและการส่งออก",
  "nav.logRetention": "ระยะเวลาเก็บบันทึก",
  "nav.openMenu": "เปิดเมนูนำทาง",
  "nav.main": "เมนูหลัก",
  "nav.collapse": "ย่อแถบเมนู",
  "nav.expand": "ขยายแถบเมนู",

  "header.docs": "เอกสาร",
  "header.help": "ช่วยเหลือ",
  "help.title": "คู่มือการใช้งาน",
  "help.contents": "สารบัญ",
  "help.onThisPage": "ในหน้านี้",
  "help.access": "ใครใช้ได้",
  "help.fields": "ช่อง",
  "help.description": "คืออะไร / ใช้ทำอะไร",
  "help.required": "จำเป็น",
  "help.steps": "ขั้นตอน",
  "help.tips": "เคล็ดลับ",
  "help.warnings": "ข้อควรระวัง",
  "help.related": "อ่านต่อ",
  "help.noImage": "ยังไม่มีภาพหน้าจอ",
  "help.openImage": "เปิดภาพขนาดเต็ม",
  "help.notFound": "ไม่พบหน้านี้ในคู่มือ เลือกหัวข้อจากสารบัญ",
  "header.account": "บัญชีของฉัน",
  "header.signOut": "ออกจากระบบ",
  "header.language": "ภาษา",
  "header.userMenu": "เมนูบัญชี",
  "header.sections": "หัวข้อย่อย",
  "footer.version": "เวอร์ชัน {{version}}",

  "login.heroTitle": "จัดการทุกบัญชีได้ในที่เดียว",
  "login.heroBody": "ผู้ใช้ กลุ่ม บทบาท และแอปที่แต่ละคนเข้าใช้ได้ พร้อมบันทึกทุกการเปลี่ยนแปลงใน audit log",
  "login.title": "เข้าสู่ระบบคอนโซล",
  "login.subtitle": "จัดการผู้ใช้ บทบาท วิธีเข้าสู่ระบบ และ OAuth clients",
  "login.button": "เข้าสู่ระบบด้วย {{name}}",
  "login.hint":
    "ระบบจะพาไปหน้าเข้าสู่ระบบของ auth server (อีเมล เบอร์โทร หรือรหัสผู้ใช้งาน แล้วยืนยันตัวตนสองขั้นตอน) แล้วพากลับมาที่นี่",
  "login.expired": "เซสชันหมดอายุ · เข้าสู่ระบบอีกครั้งแล้วจะกลับไปหน้าเดิม",
  "login.signedOut": "ออกจากระบบแล้ว",
  "login.unavailable": "ติดต่อ auth server ไม่ได้ ลองใหม่อีกสักครู่",
  "auth.redirecting": "กำลังไปยังหน้าเข้าสู่ระบบ…",
  "auth.callback": "กำลังเข้าสู่ระบบ…",
  "auth.failed": "เข้าสู่ระบบไม่สำเร็จ",
  "auth.tryAgain": "ลองอีกครั้ง",
  "auth.noAccessTitle": "ไม่มีสิทธิ์เข้าถึง",
  "auth.noAccessBody":
    "บัญชีของคุณ ({{email}}) ไม่มีสิทธิ์ใช้งานคอนโซลผู้ดูแลระบบ กรุณาติดต่อผู้ดูแลเพื่อขอบทบาท",
  "auth.initialPassword":
    "root ยังใช้รหัสผ่านเริ่มต้นที่ระบบสุ่มให้ (อ่านได้ด้วย `root:initial-password`) แนะนำให้เปลี่ยนรหัสผ่าน",
  "auth.changePassword": "เปลี่ยนรหัสผ่าน",
  "auth.mfaRequired": "บทบาทของคุณต้องใช้การยืนยันตัวตนสองขั้นตอน กรุณาตั้งค่าเพื่อใช้งานต่อ",
  "auth.mfaSetup": "ตั้งค่า 2FA",

  "error.forbidden": "คุณไม่มีสิทธิ์ดำเนินการนี้",
  "error.rateLimited": "มีคำขอมากเกินไป กรุณาลองใหม่ใน {{seconds}} วินาที",
  "error.network": "เชื่อมต่อเครือข่ายไม่ได้ กรุณาตรวจสอบการเชื่อมต่อ",

  "overview.totalUsers": "ผู้ใช้ทั้งหมด",
  "overview.active7d": "ใช้งาน (7 วัน)",
  "overview.signInsToday": "เข้าสู่ระบบวันนี้",
  "overview.failed24h": "เข้าสู่ระบบล้มเหลว (24 ชม.)",
  "overview.mfaAdoption": "การใช้ MFA",
  "overview.chartTitle": "การเข้าสู่ระบบ 14 วันล่าสุด",
  "overview.chartLabel": "กราฟเส้นแสดงจำนวนการเข้าสู่ระบบรายวันใน 14 วันล่าสุด",
  "overview.recent": "เหตุการณ์ล่าสุด",
  "overview.viewAll": "ดูบันทึกทั้งหมด",

  "users.searchPlaceholder": "ค้นหาด้วยอีเมล เบอร์โทร ชื่อ รหัสผู้ใช้ หรือรหัสพนักงาน",
  "users.add": "เพิ่มผู้ใช้",
  "users.empty": "ยังไม่มีผู้ใช้ — เพิ่มผู้ใช้คนแรก",
  "users.emptyFiltered": "ไม่พบผู้ใช้ที่ตรงกับตัวกรอง",
  "users.col.identifier": "ผู้ใช้",
  "users.col.providers": "ผู้ให้บริการ",
  "users.col.created": "สร้างเมื่อ",
  "users.col.lastSignIn": "เข้าสู่ระบบล่าสุด",
  "users.col.status": "สถานะ",
  "users.col.roles": "บทบาท",
  "users.filter.status": "สถานะ",
  "users.filter.role": "บทบาท",
  "users.filter.mfa": "MFA",
  "users.filter.mfaOn": "เปิด MFA",
  "users.filter.mfaOff": "ไม่เปิด MFA",
  "users.table": "ผู้ใช้",
  "status.active": "ใช้งาน",
  "status.banned": "ถูกระงับ",
  "status.pending": "รอยืนยัน",
  "users.dialog.title": "เพิ่มผู้ใช้",
  "users.dialog.email": "อีเมล",
  "users.dialog.name": "ชื่อที่แสดง",
  "users.dialog.userCode": "รหัสผู้ใช้งาน (ไม่บังคับ)",
  "users.dialog.userCodeInvalid":
    "ใช้ตัวอักษรภาษาอังกฤษ ตัวเลข . _ หรือ - 3–32 ตัว (และต้องไม่ใช่เบอร์โทรศัพท์)",
  "users.dialog.userCodeTaken": "รหัสผู้ใช้งานนี้มีคนใช้แล้ว",
  "users.dialog.username": "ชื่อผู้ใช้ (ไม่บังคับ)",
  "users.dialog.usernameInvalid":
    "ชื่อผู้ใช้ใช้ตัวอักษรภาษาอังกฤษ ตัวเลข . _ หรือ - 3–32 ตัว (และต้องไม่ใช่เบอร์โทรศัพท์)",
  "users.dialog.usernameTaken": "ชื่อผู้ใช้นี้มีคนใช้แล้ว",
  "users.dialog.roles": "บทบาท",
  "users.dialog.sendInvite": "ส่งอีเมลเชิญให้ผู้ใช้ตั้งรหัสผ่าน",
  "users.dialog.submit": "เพิ่มผู้ใช้",
  "users.created": "สร้างผู้ใช้แล้ว",
  "users.provider.password": "อีเมล/รหัสผ่าน",

  "user.back": "กลับไปหน้าผู้ใช้",
  "user.tab.profile": "โปรไฟล์",
  "user.tab.security": "ความปลอดภัย",
  "user.tab.roles": "บทบาท",
  "user.tab.sessions": "เซสชัน",
  "user.tab.identifiers": "อีเมล/เบอร์โทร",
  "ident.hint":
    "ผู้ใช้เข้าสู่ระบบได้ด้วยอีเมลหรือเบอร์โทรศัพท์ที่ยืนยันแล้วทุกรายการ อีเมลหลักคืออีเมลของบัญชีที่แอปพลิเคชันได้รับ (OIDC email)",
  "ident.type": "ประเภท",
  "ident.type.email": "อีเมล",
  "ident.type.phone": "เบอร์โทรศัพท์",
  "ident.type.user_code": "รหัสผู้ใช้งาน",
  "ident.type.username": "ชื่อผู้ใช้",
  "ident.valueNameHint":
    "3–32 ตัว: ตัวอักษรภาษาอังกฤษ ตัวเลข . _ - (ขึ้นต้นด้วยตัวเลขได้ แต่ต้องไม่ใช่เบอร์โทรศัพท์) ห้ามซ้ำกับรหัสผู้ใช้งานหรือชื่อผู้ใช้ของคนอื่น ใช้รหัสผ่านเดียวกับบัญชีในการเข้าสู่ระบบ",
  "users.rootBadge": "root",
  "users.rootHint": "ผู้ใช้สูงสุดของระบบ — มีแต่ root เองที่แก้ไขบัญชีนี้ได้",
  "ident.value": "อีเมลหรือเบอร์โทรศัพท์",
  "ident.valuePhoneHint": "เบอร์ในประเทศ เช่น 081 234 5678 จะถูกบันทึกเป็น +66812345678",
  "ident.status": "สถานะ",
  "ident.added": "เพิ่มเมื่อ",
  "ident.primary": "หลัก",
  "ident.verified": "ยืนยันแล้ว",
  "ident.unverified": "ยังไม่ยืนยัน",
  "ident.add": "เพิ่ม",
  "ident.addTitle": "เพิ่มอีเมลหรือเบอร์โทรศัพท์",
  "ident.markVerifiedOnAdd": "ยืนยันแล้ว (ตรวจสอบนอกระบบแล้ว)",
  "ident.markVerifiedHint": "ถ้าไม่เลือก ผู้ใช้ต้องยืนยันด้วยรหัสจากหน้าบัญชีของตนเอง",
  "ident.makePrimary": "ตั้งเป็นหลัก",
  "ident.verifyNow": "ทำเครื่องหมายว่ายืนยันแล้ว",
  "ident.remove": "ลบ",
  "ident.actions": "การทำงานสำหรับ {{value}}",
  "ident.addedToast": "เพิ่มแล้ว",
  "ident.removedToast": "ลบแล้ว",
  "ident.primaryToast": "เปลี่ยนรายการหลักแล้ว",
  "ident.verifiedToast": "ทำเครื่องหมายว่ายืนยันแล้ว",
  "ident.removeTitle": "ลบรายการนี้?",
  "ident.removeBody": "{{value}} จะใช้เข้าสู่ระบบบัญชีนี้ไม่ได้อีก",
  "ident.primaryTitle": "ตั้งเป็นอีเมลหลัก?",
  "ident.primaryBody":
    "แอปพลิเคชันจะได้รับ {{value}} เป็นอีเมลของผู้ใช้ ส่วนอีเมลหลักเดิมจะกลายเป็นอีเมลเพิ่มเติม",
  "signin.phone": "เบอร์โทรศัพท์",
  "signin.phoneEnabled": "อนุญาตให้เข้าสู่ระบบด้วยเบอร์โทรศัพท์ที่ยืนยันแล้วและรหัสผ่าน",
  "signin.phoneOtp": "อนุญาตให้เข้าสู่ระบบด้วยรหัสครั้งเดียวทาง SMS",
  "signin.smsMissing":
    "เซิร์ฟเวอร์ยังไม่ได้ตั้งค่า SMS (SMS_PROVIDER) — ผู้ใช้ยืนยันเบอร์เองไม่ได้ และยังใช้รหัสทาง SMS ไม่ได้",
  "user.tab.activity": "กิจกรรม",
  "user.tabs": "ข้อมูลผู้ใช้",
  "user.id": "รหัสผู้ใช้",
  "user.displayName": "ชื่อที่แสดง",
  "user.email": "อีเมล",
  "user.emailVerified": "ยืนยันอีเมลแล้ว",
  "user.employeeCode": "รหัสพนักงาน",
  "user.firstName": "ชื่อ",
  "user.lastName": "นามสกุล",
  "user.department": "แผนก",
  "user.position": "ตำแหน่ง",
  "user.customFields": "ฟิลด์เพิ่มเติม",
  "user.saveProfile": "บันทึกโปรไฟล์",
  "user.mfa": "การยืนยันตัวตนสองขั้นตอน",
  "user.mfaOn": "เปิดใช้งาน",
  "user.mfaOff": "ยังไม่ได้ตั้งค่า",
  "user.resetMfa": "รีเซ็ต MFA",
  "user.resetMfaConfirm": "ลบแอปยืนยันตัวตนและรหัสสำรองของผู้ใช้นี้หรือไม่ ผู้ใช้จะต้องตั้งค่าใหม่",
  "user.mfaReset": "รีเซ็ต MFA แล้ว",
  "user.passwordReset": "ส่งลิงก์ตั้งรหัสผ่านใหม่",
  "user.passwordResetSent": "ส่งอีเมลตั้งรหัสผ่านใหม่แล้ว",
  "user.password": "รหัสผ่าน",
  "user.setPassword.action": "ตั้งรหัสผ่านใหม่",
  "user.setPassword.title": "ตั้งรหัสผ่านใหม่",
  "user.setPassword.generate": "ให้ระบบสุ่มรหัสผ่าน (แสดงครั้งเดียว)",
  "user.setPassword.type": "กำหนดรหัสผ่านเอง",
  "user.setPassword.new": "รหัสผ่านใหม่",
  "user.setPassword.confirm": "ยืนยันรหัสผ่าน",
  "user.setPassword.mismatch": "รหัสผ่านไม่ตรงกัน",
  "user.setPassword.hint":
    "ผู้ใช้จะถูกออกจากระบบทุกเครื่อง และต้องตั้งรหัสผ่านของตัวเองตอนเข้าสู่ระบบครั้งถัดไป",
  "user.setPassword.submit": "ตั้งรหัสผ่าน",
  "user.setPassword.done": "ตั้งรหัสผ่านแล้ว ผู้ใช้ต้องเปลี่ยนรหัสตอนเข้าสู่ระบบครั้งถัดไป",
  "user.setPassword.once": "คัดลอกตอนนี้แล้วส่งให้ผู้ใช้ทางช่องทางส่วนตัว — จะไม่แสดงอีก",
  "user.linkedProviders": "บัญชีที่เชื่อมต่อ",
  "user.saveRoles": "บันทึกบทบาท",
  "user.rolesSaved": "อัปเดตบทบาทแล้ว",
  "user.sessions.empty": "ไม่มีเซสชันที่ใช้งานอยู่",
  "user.sessions.revoke": "ยกเลิก",
  "user.sessions.revokeAll": "ยกเลิกทุกเซสชัน",
  "user.sessions.revoked": "ยกเลิกเซสชันแล้ว",
  "user.sessions.created": "เริ่มเมื่อ",
  "user.sessions.expires": "หมดอายุ",
  "user.sessions.device": "อุปกรณ์",
  "user.danger": "โซนอันตราย",
  "user.ban": "ระงับผู้ใช้",
  "user.banTitle": "ระงับ {{email}}",
  "user.banReason": "เหตุผล",
  "user.banHint": "ผู้ใช้จะถูกออกจากระบบทุกอุปกรณ์ และเข้าสู่ระบบไม่ได้จนกว่าจะยกเลิกการระงับ",
  "user.banned": "ระงับผู้ใช้แล้ว",
  "user.unban": "ยกเลิกการระงับ",
  "user.unbanned": "ยกเลิกการระงับแล้ว",
  "user.bannedBecause": "ถูกระงับ: {{reason}}",
  "user.delete": "ลบผู้ใช้",
  "user.deleteTitle": "ลบ {{email}}",
  "user.deleteConfirm": "การลบจะลบบัญชีและโปรไฟล์ถาวร พิมพ์อีเมลเพื่อยืนยัน",
  "user.deleted": "ลบผู้ใช้แล้ว",
  "user.export": "ส่งออกข้อมูล (PDPA)",
  "user.created": "สร้างเมื่อ {{date}}",

  "signin.provider": "ผู้ให้บริการ",
  "signin.status": "สถานะ",
  "signin.emailPassword": "อีเมล/รหัสผ่าน",
  "signin.google": "Google",
  "signin.microsoft": "Microsoft",
  "signin.passkey": "Passkey",
  "signin.unsupported": "ยังไม่รองรับ",
  "signin.notConfigured":
    "ยังไม่ได้ตั้งค่า secret ของ {{provider}} บนเซิร์ฟเวอร์ — ตั้งค่าใน environment ก่อนเปิดใช้งาน",
  "signin.editTitle": "แก้ไข {{provider}}",
  "signin.enable": "เปิดใช้งาน",
  "signin.allowSignUp": "อนุญาตให้สมัครสมาชิกเอง",
  "signin.requireVerification": "ต้องยืนยันอีเมล",
  "signin.domains": "โดเมนอีเมลที่อนุญาต",
  "signin.domainsHint": "เว้นว่างเพื่ออนุญาตทุกโดเมน ตัวอย่าง: company.co.th",
  "signin.addDomain": "เพิ่มโดเมน",
  "signin.minLength": "ความยาวรหัสผ่านขั้นต่ำ",
  "signin.mfa": "การยืนยันตัวตนหลายขั้นตอน",
  "signin.mfaPolicy": "นโยบาย",
  "signin.policy.optional": "ไม่บังคับ",
  "signin.policy.required_for_admins": "บังคับสำหรับผู้ดูแลระบบ",
  "signin.policy.required_for_all": "บังคับทุกคน",
  "signin.methods": "วิธีการ",
  "signin.method.totp": "แอปยืนยันตัวตน (TOTP)",
  "signin.method.email_otp": "รหัสทางอีเมล",
  "signin.session": "เซสชัน",
  "signin.maxAge": "อายุเซสชัน (วัน)",
  "signin.idle": "หมดเวลาเมื่อไม่ใช้งาน (นาที, ไม่บังคับ)",
  "signin.save": "บันทึกการเปลี่ยนแปลง",
  "signin.conflict": "การตั้งค่าถูกแก้ไขโดยผู้อื่นแล้ว — โหลดใหม่เพื่อดูเวอร์ชันล่าสุด",

  "roles.add": "สร้างบทบาท",
  "roles.name": "ชื่อ",
  "roles.description": "คำอธิบาย",
  "roles.permissions": "สิทธิ์",
  "roles.builtIn": "มีในระบบ",
  "roles.editTitle": "แก้ไขบทบาท {{name}}",
  "roles.createTitle": "สร้างบทบาท",
  "roles.nameHint": "ตัวพิมพ์เล็ก ตัวเลข - หรือ _ เปลี่ยนภายหลังไม่ได้",
  "roles.deleteConfirm": "ลบบทบาท {{name}} หรือไม่",
  "roles.empty": "ไม่มีบทบาท",
  "perm.users": "ผู้ใช้",
  "perm.roles": "บทบาท",
  "perm.logs": "บันทึกการใช้งาน",
  "perm.settings": "การตั้งค่า",
  "perm.clients": "OAuth clients",
  "perm.data": "ข้อมูล",

  "fields.add": "เพิ่มฟิลด์",
  "fields.key": "คีย์",
  "fields.labelTh": "ชื่อ (ไทย)",
  "fields.labelEn": "ชื่อ (อังกฤษ)",
  "fields.type": "ชนิด",
  "fields.options": "ตัวเลือก (บรรทัดละหนึ่งค่า)",
  "fields.required": "บังคับกรอก",
  "fields.showOnSignUp": "แสดงในหน้าสมัครสมาชิก",
  "fields.includeInClaims": "ส่งใน token claims (scope employee)",
  "fields.empty": "ยังไม่มีฟิลด์เพิ่มเติม — เพิ่มเพื่อขยายข้อมูลพนักงาน",
  "fields.type.string": "ข้อความ",
  "fields.type.number": "ตัวเลข",
  "fields.type.boolean": "ใช่/ไม่ใช่",
  "fields.type.date": "วันที่",
  "fields.type.select": "ตัวเลือก",
  "fields.editTitle": "แก้ไขฟิลด์",
  "fields.save": "บันทึกฟิลด์",

  "clients.register": "ลงทะเบียน client",
  "clients.empty": "ยังไม่มี OAuth client — ลงทะเบียนแอปพลิเคชันแรก",
  "clients.col.name": "ชื่อ",
  "clients.col.clientId": "Client ID",
  "clients.col.type": "ประเภท",
  "clients.col.status": "สถานะ",
  "clients.firstParty": "แอปภายใน",
  "clients.type.confidential": "Confidential",
  "clients.type.public": "Public (SPA / มือถือ)",
  "clients.name": "ชื่อแอปพลิเคชัน",
  "clients.redirectUris": "Redirect URIs",
  "clients.postLogoutUris": "Post-logout redirect URIs",
  "clients.addUri": "เพิ่ม URI",
  "clients.scopes": "Scopes ที่อนุญาต",
  "clients.firstPartyHint": "แอปภายในจะข้ามหน้าขอความยินยอม",
  "clients.backchannel": "Back-channel logout URI",
  "clients.ownerTeam": "ทีมเจ้าของ",
  "clients.description": "คำอธิบาย",
  "clients.secretTitle": "Client secret",
  "clients.secretWarning": "คัดลอก secret นี้ทันที ระบบจะไม่แสดงอีก",
  "clients.secretDone": "ฉันเก็บ secret แล้ว",
  "clients.rotate": "สร้าง secret ใหม่",
  "clients.rotateConfirm": "secret เดิมจะใช้ไม่ได้ทันที ต้องการดำเนินการต่อหรือไม่",
  "clients.disable": "ปิดใช้งาน",
  "clients.enable": "เปิดใช้งาน",
  "clients.tab.settings": "การตั้งค่า",
  "clients.tab.integration": "การเชื่อมต่อ",
  "clients.issuer": "Issuer",
  "clients.discovery": "Discovery URL",
  "clients.snippets": "ตัวอย่างโค้ด",
  "clients.back": "กลับไปหน้า clients",
  "clients.saved": "อัปเดต client แล้ว",
  "clients.registered": "ลงทะเบียน client แล้ว",

  "logs.type": "ประเภทเหตุการณ์",
  "logs.actor": "รหัสผู้กระทำ",
  "logs.subject": "รหัสผู้ใช้ที่เกี่ยวข้อง",
  "logs.from": "ตั้งแต่",
  "logs.to": "ถึง",
  "logs.apply": "ใช้ตัวกรอง",
  "logs.clear": "ล้าง",
  "logs.loadMore": "โหลดเพิ่ม",
  "logs.exportCsv": "ส่งออก CSV",
  "logs.col.time": "เวลา",
  "logs.col.event": "เหตุการณ์",
  "logs.col.actor": "ผู้กระทำ",
  "logs.col.subject": "ผู้ใช้",
  "logs.col.ip": "IP",
  "logs.empty": "ไม่พบเหตุการณ์",
  "logs.details": "ดูรายละเอียด",
  "logs.table": "บันทึกการใช้งาน",

  "branding.productName": "ชื่อผลิตภัณฑ์",
  "branding.logoUrl": "URL โลโก้",
  "branding.primaryColor": "สีหลัก",
  "branding.supportEmail": "อีเมลฝ่ายสนับสนุน",
  "branding.preview": "ตัวอย่าง",
  "branding.previewButton": "เข้าสู่ระบบ",
  "clients.tab.branding": "แบรนด์",
  "clientBranding.hint":
    "หน้าตาของหน้าเข้าสู่ระบบเมื่อผู้ใช้มาจากแอปนี้ ช่องที่ว่างจะใช้ค่าจาก การตั้งค่า → แบรนด์",
  "clientBranding.ownColor": "ใช้สีเฉพาะของแอปนี้",
  "clientBranding.logoHint": "รูปภาพ HTTPS แสดงแทนโลโก้ของระบบ",
  "clientBranding.open": "เปิดหน้าเข้าสู่ระบบ",
  "heroText.section": "ข้อความหน้าเข้าสู่ระบบ",
  "heroText.globalHint":
    "หัวข้อและข้อความฝั่งซ้ายของหน้าเข้าสู่ระบบ ถ้าเว้นว่างจะใช้ข้อความเริ่มต้น (แสดงเป็นตัวจาง)",
  "heroText.appHint": "ถ้าเว้นว่างจะใช้ข้อความจาก การตั้งค่า → แบรนด์ (แสดงเป็นตัวจาง)",
  "heroText.title.th": "หัวข้อ (ไทย)",
  "heroText.title.en": "หัวข้อ (อังกฤษ)",
  "heroText.body.th": "ข้อความ (ไทย)",
  "heroText.body.en": "ข้อความ (อังกฤษ)",
  "heroText.titleHint": "กด Enter เพื่อขึ้นบรรทัดใหม่",
  "branding.previewLink": "ลืมรหัสผ่าน?",

  "data.start": "เริ่มส่งออก",
  "data.includeLogs": "รวมบันทึกการใช้งาน",
  "data.includeCredentials": "รวมข้อมูลรับรอง (hash รหัสผ่าน, TOTP secret — เข้ารหัส)",
  "data.jobs": "งานส่งออก",
  "data.empty": "ยังไม่มีการส่งออก",
  "data.finished": "เสร็จเมื่อ",
  "data.status.pending": "รอดำเนินการ",
  "data.status.running": "กำลังทำงาน",
  "data.status.done": "เสร็จสิ้น",
  "data.status.failed": "ล้มเหลว",
  "data.started": "เริ่มส่งออกแล้ว",
  "data.import": "นำเข้า",
  "data.importHint":
    "ใช้ CLI สำหรับนำเข้า: pnpm --filter @platform/auth-server cli import --in file.jsonl --dry-run",

  "retention.days": "เก็บบันทึกการใช้งาน (วัน)",
  "retention.hint": "รายการที่เก่ากว่านี้จะถูกลบอัตโนมัติทุกไม่กี่ชั่วโมง",

  "nav.groups": "กลุ่ม",
  "nav.userTypes": "ประเภทผู้ใช้",
  "perm.groups": "กลุ่ม",
  "user.tab.access": "สิทธิ์เข้าถึง",
  "users.dialog.userTypeHint": "บทบาทคอนโซลให้ได้เฉพาะผู้ใช้ประเภท employee เท่านั้น",
  "clients.col.access": "สิทธิ์เข้าถึง",
  "clients.tab.access": "สิทธิ์เข้าถึง",

  "access.userType": "ประเภทผู้ใช้",
  "access.userTypes": "ประเภทผู้ใช้",
  "access.groups": "กลุ่ม",
  "access.everyone": "ทุกคน",
  "access.everyoneHint": "บัญชีที่ใช้งานอยู่ทุกบัญชีเข้าสู่ระบบได้ รวมถึงลูกค้าที่สมัครเอง",
  "access.restricted": "เฉพาะประเภทผู้ใช้และกลุ่มที่เลือก",
  "access.restrictedHint":
    "บัญชีที่เป็นประเภทผู้ใช้ที่เลือก หรือเป็นสมาชิกของกลุ่มที่เลือก จึงเข้าสู่ระบบได้",
  "access.nobody": "ไม่มีใคร",
  "access.whoCanSignIn": "ใครเข้าสู่ระบบได้บ้าง",
  "access.needOne": "เลือกประเภทผู้ใช้หรือกลุ่มอย่างน้อยหนึ่งรายการ",
  "access.signUpAs": "อนุญาตให้สมัครเป็น",
  "access.signUpAsHint": "ผู้เข้าชมแอปนี้สร้างบัญชีประเภทนี้เองได้ · แสดงเฉพาะประเภทที่เปิด self sign-up ไว้",
  "access.noSignUp": "ไม่เปิดให้สมัคร",
  "access.signUpNotAllowed": "ประเภทผู้ใช้นี้ไม่อนุญาตให้สมัครเอง (self sign-up)",
  "access.signUpNotListed": "ประเภทที่ใช้สมัครต้องอยู่ในประเภทผู้ใช้ที่เลือกด้วย",
  "access.revokeHint":
    "เมื่อจำกัดสิทธิ์ให้แคบลง token ของผู้ใช้ที่ไม่มีสิทธิ์แล้วจะถูกเพิกถอนทันที และถูกออกจากระบบของแอปนี้",
  "access.consoleManaged":
    "สิทธิ์เข้าคอนโซลผู้ดูแลจัดการโดยแพลตฟอร์ม: เฉพาะบัญชีที่มีบทบาทคอนโซลเท่านั้นที่เข้าได้",
  "access.newDefault": "แอปใหม่อนุญาตเฉพาะ employee · เปลี่ยนได้ตอนนี้หรือภายหลังในแท็บสิทธิ์เข้าถึง",
  "access.typeHint":
    "ประเภทผู้ใช้กำหนดว่าบัญชีใช้แอปใดได้บ้าง · การเปลี่ยนประเภทจะเพิกถอน token ของแอปต่าง ๆ ของผู้ใช้",
  "access.rootSystem":
    "root เป็นบัญชีระบบ ไม่มีประเภทผู้ใช้ เพิ่มเข้ากลุ่มไม่ได้ และเข้าสู่ระบบได้เฉพาะ Console นี้เท่านั้น เข้าแอปอื่นไม่ได้",
  "access.systemAccount": "บัญชีระบบ",
  "access.changeType": "เปลี่ยนประเภท",
  "access.changeTypeTitle": "เปลี่ยนประเภทผู้ใช้",
  "access.changeTypeBody":
    "เปลี่ยน {{email}} จาก {{from}} เป็น {{to}}? ผู้ใช้จะถูกออกจากระบบของแอปที่ไม่มีสิทธิ์ใช้แล้ว",
  "access.typeChanged": "เปลี่ยนประเภทผู้ใช้แล้ว",
  "access.groupsHint": "กลุ่มให้สิทธิ์เข้าแอปที่อนุญาตกลุ่มนั้น และแสดงใน groups claim ของ token",
  "access.saveGroups": "บันทึกกลุ่ม",
  "access.groupsSaved": "อัปเดตกลุ่มแล้ว",
  "access.applications": "แอปพลิเคชัน",
  "access.applicationsHint": "ผู้ใช้นี้เข้าสู่ระบบแต่ละแอปได้หรือไม่ ตามประเภทและกลุ่ม",
  "access.canSignIn": "เข้าได้",
  "access.cannotSignIn": "ไม่มีสิทธิ์",
  "access.rolesEmployeesOnly": "บทบาทคอนโซลให้ได้เฉพาะ employee เท่านั้น",
  "access.slugInvalid": "2–41 ตัวอักษร: ขึ้นต้นด้วยตัวพิมพ์เล็ก ตามด้วย a–z, 0–9, - หรือ _",

  "groups.intro": "กลุ่มคือทีมของผู้ใช้ · แอปอนุญาตกลุ่มได้ และ id ของกลุ่มจะแสดงใน groups claim ของ token",
  "groups.add": "สร้างกลุ่ม",
  "groups.createTitle": "สร้างกลุ่ม",
  "groups.created": "สร้างกลุ่มแล้ว",
  "groups.id": "ID",
  "groups.idHint": "ตัวพิมพ์เล็ก ตัวเลข - หรือ _ (เช่น chat-agents) · แสดงใน token และเปลี่ยนภายหลังไม่ได้",
  "groups.name": "ชื่อ",
  "groups.description": "คำอธิบาย",
  "groups.members": "สมาชิก",
  "groups.memberCount": "สมาชิก {{count}} คน",
  "groups.membersHint": "การนำสมาชิกออกจะเพิกถอน token ของแอปที่เขาไม่มีสิทธิ์ใช้แล้ว",
  "groups.empty": "ยังไม่มีกลุ่ม",
  "groups.noMembers": "ยังไม่มีสมาชิก",
  "groups.back": "กลับไปหน้ากลุ่ม",
  "groups.addMembers": "เพิ่มสมาชิก",
  "groups.addMembersTitle": "เพิ่มสมาชิกใน {{name}}",
  "groups.addSelected": "เพิ่ม {{count}} คนที่เลือก",
  "groups.alreadyMember": "เป็นสมาชิกแล้ว",
  "groups.searchResults": "ผู้ใช้",
  "groups.membersAdded": "เพิ่มสมาชิก {{count}} คนแล้ว",
  "groups.memberRemoved": "นำสมาชิกออกแล้ว",
  "groups.removeMemberTitle": "นำสมาชิกออก",
  "groups.removeMemberBody": "นำ {{name}} ออกจาก {{group}}?",
  "groups.removeMemberLabel": "นำ {{name}} ออก",
  "groups.applications": "แอปที่ใช้กลุ่มนี้",
  "groups.noApplications": "ยังไม่มีแอปที่อนุญาตกลุ่มนี้",
  "groups.delete": "ลบกลุ่ม",
  "groups.deleteTitle": "ลบกลุ่ม {{name}}",
  "groups.deleteBody":
    "สมาชิกจะเสียสิทธิ์ที่ได้จากกลุ่มนี้ · ลบไม่ได้ถ้ายังมีแอปหรือประเภทผู้ใช้ใช้กลุ่มนี้อยู่",
  "groups.deleted": "ลบกลุ่มแล้ว",

  "userTypes.intro":
    "ทุกบัญชีมีประเภทผู้ใช้หนึ่งประเภท (employee, customer, partner หรือประเภทที่สร้างเอง) · แอปอนุญาตตามประเภทผู้ใช้ และประเภทจะแสดงใน token เป็น user_type",
  "userTypes.domainsExplain":
    "Email domains: ผู้ที่สมัครด้วยอีเมลโดเมนเหล่านี้จะได้ประเภทนี้ (เช่น โดเมนบริษัท → employee)",
  "userTypes.add": "สร้างประเภทผู้ใช้",
  "userTypes.createTitle": "สร้างประเภทผู้ใช้",
  "userTypes.editTitle": "แก้ไขประเภทผู้ใช้ {{name}}",
  "userTypes.id": "ID",
  "userTypes.idHint": "ตัวพิมพ์เล็ก ตัวเลข - หรือ _ · แสดงใน token และเปลี่ยนภายหลังไม่ได้",
  "userTypes.name": "ชื่อ",
  "userTypes.description": "คำอธิบาย",
  "userTypes.accounts": "จำนวนบัญชี",
  "userTypes.selfSignUp": "สมัครเองได้ (self sign-up)",
  "userTypes.selfSignUpHint": "ผู้เข้าชมสร้างบัญชีประเภทนี้เองได้ ผ่านแอปที่เปิดให้สมัครเป็นประเภทนี้",
  "userTypes.emailDomains": "Email domains",
  "userTypes.emailDomainsHint":
    "บรรทัดละหนึ่งโดเมน · ผู้ที่สมัครด้วยโดเมนเหล่านี้จะได้ประเภทนี้ · *.example.com ครอบคลุม sub-domain",
  "userTypes.mfa": "กฎ 2FA",
  "userTypes.mfaHint": "Inherit = ใช้นโยบายรวมในหน้าวิธีเข้าสู่ระบบ",
  "userTypes.mfa.inherit": "ตามนโยบายรวม (inherit)",
  "userTypes.mfa.optional": "ไม่บังคับ",
  "userTypes.mfa.required": "บังคับ",
  "userTypes.defaultGroups": "กลุ่มเริ่มต้น",
  "userTypes.defaultGroupsHint": "บัญชีใหม่ของประเภทนี้จะเข้ากลุ่มเหล่านี้อัตโนมัติ",
  "userTypes.empty": "ไม่มีประเภทผู้ใช้",
  "userTypes.deleteConfirm": "ลบประเภทผู้ใช้ {{name}}? จะลบไม่ได้ถ้ายังมีบัญชีหรือแอปใช้อยู่",
};
